import PQueue from "p-queue";
const queue = new PQueue({ concurrency: 5 });
function preloadImage(url) {
  const { resolve, promise } = Promise.withResolvers();
  queue.add(() => {
    const image = new Image();
    image.onerror = () => resolve(false);
    image.onload = () => resolve(true);
    image.src = url;
    return promise;
  });
  return promise;
}
export {
  preloadImage
};
//# sourceMappingURL=preloadImage.mjs.map
